import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "chevron"]

  toggle(event) {
    event.stopPropagation()
    this.panelTarget.classList.toggle("hidden")
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180")
    }
  }

  close() {
    this.panelTarget.classList.add("hidden")
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.remove("rotate-180")
    }
  }
}
